






























import { defineComponent } from "@vue/composition-api";

import { Section } from "@/tools/msa/models";

interface Props {
  section: Section;
}

export default defineComponent<Props>({
  name: "SectionSwitch",
  props: {
    section: { type: Object, required: true }
  }
});
